// extracted by mini-css-extract-plugin
export default {"innerWrapper":"qs-z","tooltipWrapper":"rs-z","icon":"ss-z","tooltip":"ts-z","content":"us-z"};